import Vue from 'vue';
import types from '../../mutation-types';

export const mutations = {
  [types.SET_CONTACT_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [types.CLEAR_CONTACTS]: $state => {
    Vue.set($state, 'records', {});
    Vue.set($state, 'sortOrder', []);
    // Reset pagination meta so the footer doesn't show stale "1-15 of 50"
    // over an empty table (e.g. when the short-query guard clears results
    // without a follow-up SET_CONTACT_META). Existing callers that fire
    // SET_CONTACT_META right after CLEAR_CONTACTS are unaffected — their
    // mutation overrides these values immediately.
    Vue.set($state.meta, 'count', 0);
    Vue.set($state.meta, 'currentPage', 1);
  },

  [types.SET_CONTACT_META]: ($state, data) => {
    const { count, current_page: currentPage } = data;
    Vue.set($state.meta, 'count', count);
    Vue.set($state.meta, 'currentPage', currentPage);
  },

  [types.SET_CONTACTS]: ($state, data) => {
    const sortOrder = data.map(contact => {
      Vue.set($state.records, contact.id, {
        ...($state.records[contact.id] || {}),
        ...contact,
      });
      return contact.id;
    });
    $state.sortOrder = sortOrder;
  },

  // Updates the cached record for a single contact. Does not touch
  // `sortOrder`: visible list membership/order is managed only by list
  // mutations (`SET_CONTACTS`, `ADD_CONTACT_TO_LIST`, `DELETE_CONTACT`).
  // Real-time updates (websocket events for new/updated conversations) reuse
  // this mutation to refresh contact data without polluting an active filter.
  [types.SET_CONTACT_ITEM]: ($state, data) => {
    Vue.set($state.records, data.id, {
      ...($state.records[data.id] || {}),
      ...data,
    });
  },

  // Explicitly appends a contact id to the visible list. Use this when a
  // contact must appear in the current view (e.g. just created via the form).
  [types.ADD_CONTACT_TO_LIST]: ($state, id) => {
    if (!$state.sortOrder.includes(id)) {
      $state.sortOrder.push(id);
      Vue.set($state.meta, 'count', Number($state.meta.count || 0) + 1);
    }
  },

  [types.EDIT_CONTACT]: ($state, data) => {
    const oldContact = $state.records[data.id] || {};
    Vue.set($state.records, data.id, {
      ...oldContact,
      ...data,
      contactableInboxes:
        data.contactableInboxes ?? oldContact.contactableInboxes,
    });
  },

  // Only a contact in the visible list is known to belong to the current
  // result set, so only its removal adjusts the total.
  [types.DELETE_CONTACT]: ($state, id) => {
    const index = $state.sortOrder.findIndex(item => item === id);
    if (index !== -1) {
      Vue.delete($state.sortOrder, index);
      Vue.set(
        $state.meta,
        'count',
        Math.max(0, Number($state.meta.count || 0) - 1)
      );
    }
    Vue.delete($state.records, id);
  },

  [types.UPDATE_CONTACTS_PRESENCE]: ($state, data) => {
    Object.values($state.records).forEach(element => {
      const availabilityStatus = data[element.id];
      if (availabilityStatus) {
        Vue.set(
          $state.records[element.id],
          'availability_status',
          availabilityStatus
        );
      } else {
        Vue.delete($state.records[element.id], 'availability_status');
      }
    });
  },

  [types.SET_CONTACT_FILTERS](_state, data) {
    _state.appliedFilters = data;
  },

  [types.CLEAR_CONTACT_FILTERS](_state) {
    _state.appliedFilters = [];
  },
};
